// import ChangeLog from './changelog.json'


//通用
import { Data as AuthContent } from '../authentication/index'
import { Data as ChangeLogContent } from '../changelog/index'


import { Data as AccountContent } from './api/account/index'
import { Data as TradeOrderContent } from './api/trade/index'
import { Data as MarketContent } from './api/market/index'
import { Data as BasicContent } from './api/basic/index'
import Introduce from './1_introduce.json'
import Description from './2_description.json'
import { List as SocketContent } from './websocket/index'



// import Socket from './websocket/websocket.json'
const ROOT_MODULE = "en-us/swapV2"
import { Data as QandAContent } from '../q&a/index'
const QandA = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/q&a`,
  "name": "Frequently Asked Questions",
  "content": QandAContent
}
export const Socket = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/socket`,
  "name": "Socket API Reference",
  "children": SocketContent
}


const ChangeLog = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/changelog`,
  "name": "Change Log",
  "content": ChangeLogContent
}
const TradeOrder = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/trade-api.html`,
  "name": "Trades Endpoints",
  "content": TradeOrderContent
}
const Authentication = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/authentication.html`,
  "name": "Authentication",
  "content": AuthContent
}
const Basic = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/base-info.html`,
  "name": "General Info",
  "content": BasicContent
}
const Account = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/account-api.html`,
  "name": "Account Endpoints",
  "content": AccountContent
}

const Market = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/market-api.html`,
  "name": "Market Data",
  "content": MarketContent
}

export const swapV2Config = [
  Introduce,
  ChangeLog,
  QandA,
  Description,
  Authentication,
  Basic,
  Market,
  Account,
  TradeOrder,
  // Other,
  Socket,
]


// WEBPACK FOOTER //
// ./src/config/en-US/swapV2/index.js